import {
	requests
}from "../../../api/agent"

export default {
	getList  : (params) => requests.getWithParams('/AccountingPeriod/getList', params),
	getPaged : (params) => requests.post('/AccountingPeriod/getPaged', params),
	create   : (params) => requests.post('/AccountingPeriod/create', params),
	change   : (params) => requests.post('/AccountingPeriod/change', params),
	delete   : (params) => requests.post('/AccountingPeriod/delete', params)
}